/**
 * The review step's standard look (the prototype's price line, request note
 * and submit). Draws the behavior half's state and calls its actions.
 */
import { partsOf, pieceRoot } from '../../contract/runtime';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import type { ReviewStepRuntime } from './useReviewStep';
import css from './ReviewStep.module.css';
import { contract } from './contract';

const part = partsOf(contract);

export function ReviewStepView({ state, actions }: ReviewStepRuntime) {
  // A booking that did not go through (row V7): the app's failure, in this look.
  if (state.failure) {
    return (
      <div className={css.failure} role="alert" {...pieceRoot(contract)} {...part('failure')}>
        <h2 className={css.failureTitle}>{state.failure.title}</h2>
        <p>{state.failure.message}</p>
        <div className={css.failureActions}>
          {state.failure.canRetry && (
            <button type="button" className={`${shared.btn} ${shared.btnPrimary}`} onClick={actions.retry} {...part('retry')}>
              Try Again
            </button>
          )}
          <button type="button" className={`${shared.btn} ${shared.btnOutline}`} onClick={actions.goBack} {...part('goBack')}>
            Go Back
          </button>
        </div>
      </div>
    );
  }
  return (
    <div {...pieceRoot(contract)}>
      <div className={css.line} {...part('price')}>
        <div>
          <b>{state.price.label}</b>
          <span>{state.price.value}</span>
        </div>
        {state.price.amount && <b>{state.price.amount}</b>}
      </div>
      {state.note && (
        <p className={css.note} {...part('note')}>
          <Icon name="info" small />
          <span>{state.note}</span>
        </p>
      )}
      <div className={css.submit}>
        <button
          type="button"
          className={`${shared.btn} ${shared.btnPrimary} ${css.confirm}`}
          disabled={state.confirming || state.waitingForNumber}
          onClick={actions.confirm}
          {...part('confirm', (state.confirming || state.waitingForNumber) && 'disabled')}
        >
          {state.confirmLabel}
        </button>
      </div>
    </div>
  );
}
